'use client';
import React, { useState } from 'react';
import '../styles/views/_HouseholdRadioComponent.scss';
import { useRouter } from 'next/navigation';
import useLocalePath from '@/hooks/useLocalePath';
import { useTranslation } from '@/contexts/TranslationContext';

const RadioGroup = ({ pathname, gender, shouldRedirect = false, getGender = () => {} }) => {
  const router = useRouter();
  const localePath = useLocalePath();
  const { t } = useTranslation();
  const [selected, setSelected] = useState(pathname[2] === 'household' ? 'household' : 'individual');

  const handleRadioChange = (value) => {
    setSelected(value);
    console.log('watch', 'inside handleRadioChange running');

    if (shouldRedirect) {
      if (pathname[2] === 'household') {
        const genderPath = gender === 'h' || gender === 'm' ? 'men' : 'women';
        router.push(localePath(`/${pathname[1]}/${genderPath}/${pathname[3]}`));
        console.log('watch', `/${pathname[1]}/${genderPath}/${pathname[3]}`);
      } else {
        const genderPath = 'household';
        router.push(localePath(`/${pathname[1]}/${genderPath}/${pathname[3]}`));
        console.log('watch', `/${pathname[1]}/${genderPath}/${pathname[3]}`);
      }
    } else {
      getGender(value);
    }
  };

  return (
    <div className="radio-container">
      <div className="radio-card-container">
        <label className={`radio-card ${selected === 'individual' ? 'active' : ''}`}>
          <div className="d-flex gap-2 align-items-center">
            <input
              type="radio"
              name="incomeType"
              value="individual"
              checked={selected === 'individual'}
              onClick={() => handleRadioChange('individual')}
            />
            <span className="label-text">{t('household.individual')}</span>
          </div>
        </label>
      </div>

      <div className="radio-card-container">
        <label className={`radio-card ${selected === 'household' ? 'active' : ''}`}>
          <div className="d-flex gap-2 align-items-center">
            <input
              type="radio"
              name="incomeType"
              value="household"
              checked={selected === 'household'}
              onClick={() => handleRadioChange('household')}
            />
            <span className="label-text">{t('household.household')}</span>
          </div>
        </label>
        <p className="color-light-brown mt-1">{t('household.description')}</p>
      </div>
    </div>
  );
};

export default RadioGroup;
